import DairyService from '@src/api/services/dairy';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { BankEl } from './style';
import { FormFields } from '@src/components/FormFields';
import { GlobalEl } from '@src/styles/app';
import DairyQuery from '@src/QueryHooks/DairyQuery';
import notify from '~/components/Notify';
import { useMutation } from 'react-query';
import Drawer from '~/components/Drawer';
import { handleErrors } from '~/utils/helpers';

interface CreateEditBankAccountsProps {
  isVisible: boolean;
  bankId?: string;
  bankAccountId?: string;
  handleHiddenDrawer: () => void;
  isLoading?: boolean;
  fetchData?: () => void,
  idAccount?: any
}

const CreateEditBankAccounts: React.FunctionComponent<CreateEditBankAccountsProps> = (props) => {
  const { isVisible, bankId, handleHiddenDrawer, idAccount } = props;
  const { t } = useTranslation();
  const { handleSubmit, control, reset, formState: { dirtyFields } } = useForm({
    mode: 'onSubmit'
  });

  useEffect(() => {
    if (bankId && idAccount) {
      getAccountById(bankId);
    } else {
      reset({
        iban: '',
        swift: '',
        depotNo: '',
        depotName: ''
      });
    }
  }, [bankId, isVisible, idAccount]);

  const onSuccess = () => {
    notify(t('Successfully created account'), 'success');
    props.fetchData()
  };

  const onSuccessGetAccount = (data) => {
    reset(data)
  }

  const { mutateAsync: createBankAccount } =
    DairyQuery.createBankAccount(onSuccess);

  const { isLoading: isBankUpdateLoading, mutate: editBankAccount } = useMutation(
    'accounts-edit',
    DairyService.editBankAccount,
    {
      onSuccess: () => {
        notify(t('Successfully updated bank'), 'success');
        props.fetchData()
      },
      onError: (error: any) => {
        handleErrors(error)
      }
    }
  );

  const { isLoading: isBankAccountLoading, mutateAsync: getAccountById } =
    DairyQuery.getDairyBankAccountById(onSuccessGetAccount);

  const onSubmit = (data) => {
    if (!idAccount) {
      createBankAccount({ bank_id: bankId, ...data });
    } else {
      editBankAccount({ id: bankId, data })
    }
    handleHiddenDrawer();
  };

  const renderContent = () => {
    return (
      <>
        <FormFields.Input
          rules={{ required: { value: true, message: t('Please enter IBAN') } }}
          control={control}
          fluid
          name={'iban'}
          label={t('IBAN')}
          placeholder={t('IBAN')}
        />
        <FormFields.Input
          rules={{ required: { value: true, message: t('Please enter  Swift') } }}
          control={control}
          fluid
          label={t('Swift')}
          name={'swift'}
          placeholder={t('Swift')}
        />
        <FormFields.Input
          rules={{ required: { value: true, message: t('Please enter number of the Depot') } }}
          control={control}
          fluid
          name={'depotNo'}
          label={t('Depot Number')}
          placeholder={t('Depot Number')}
        />
        <FormFields.Input
          rules={{ required: { value: true, message: t('Please enter name of the Depot') } }}
          control={control}
          fluid
          label={t('Depot Name')}
          name={'depotName'}
          placeholder={t('Depot Name')}
        />
        <BankEl.DrawerFooter>
          <GlobalEl.PrimaryButton
            disabled={Object.keys(dirtyFields).length === 0}
          >{idAccount ? t('Update') : t('Add')}</GlobalEl.PrimaryButton>
        </BankEl.DrawerFooter>
      </>
    );
  };

  return <Drawer
    isVisible={isVisible}
    handleSubmit={handleSubmit(onSubmit)}
    isBusy={isBankAccountLoading}
    header={idAccount ? t('Edit Bank Account') : t('Create Bank Account')}
    closeOnEscape
    onHide={() => {
      //   setUpdateLogsData(null);
      reset();
      handleHiddenDrawer();
    }}
    content={renderContent()}
  />
};

export default CreateEditBankAccounts;
